/* eslint-disable react/prop-types */
import React from 'react';
import { Box, FormControl, InputLabel, Select, MenuItem, Paper, Typography, SelectChangeEvent } from '@mui/material';
import { Sort as SortIcon } from '@mui/icons-material';

export interface SortOption {
	field: string;
	label: string;
}

export interface SortConfig {
	field: string;
	order: 'asc' | 'desc';
}

interface SortSelectorProps {
	currentSort: SortConfig;
	onSortChange: (sort: SortConfig) => void;
}

const sortOptions: SortOption[] = [
	{ field: 'ticketingLimitDatetime', label: 'Fecha Límite de Emisión' },
	{ field: 'serviceCreatedAt', label: 'Fecha de Creación del Servicio' },
	{ field: 'ticketingStatus', label: 'Estado de Emisión' },
	{ field: 'serviceId', label: 'Service ID' },
	{ field: 'saleOrderId', label: 'Sale Order ID' },
	{ field: 'saleOrderDealId', label: 'Deal ID' },
	{ field: 'mainPassengerCompleteName', label: 'Pasajero Principal' },
	{ field: 'vcCode', label: 'Validating Carrier' },
	{ field: 'ticketType', label: 'Tipo de Ticket' },
	{ field: 'serviceCost', label: 'Costo del Servicio' },
	{ field: 'saleOrderChargedAmount', label: 'Monto Cobrado' },
	{ field: 'saleOrderCreatedBy', label: 'Creado por' },
	{ field: 'saleOrderAgencyId', label: 'Agencia' },
	{ field: 'providerFantasyName', label: 'Proveedor' },
	{ field: 'serviceReference', label: 'PNR' },
	{ field: 'saleOrderTravelDepartureDate', label: 'Fecha de Viaje' },
	{ field: 'serviceUpdatedAt', label: 'Última Actualización' },
];

export const SortSelector: React.FC<SortSelectorProps> = ({ currentSort, onSortChange }) => {
	const handleFieldChange = (event: SelectChangeEvent<string>) => {
		const field = event.target.value;
		onSortChange({
			field,
			order: currentSort.order,
		});
	};

	const handleOrderChange = (event: SelectChangeEvent<string>) => {
		const order = event.target.value as 'asc' | 'desc';
		onSortChange({
			field: currentSort.field,
			order,
		});
	};

	const getCurrentFieldLabel = () => {
		const option = sortOptions.find((opt) => opt.field === currentSort.field);
		return option?.label || currentSort.field;
	};

	return (
		<Paper elevation={1} sx={{ p: 2, mb: 2 }}>
			<Box display="flex" alignItems="center" gap={2}>
				<Box display="flex" alignItems="center" gap={1}>
					<SortIcon color="action" />
					<Typography variant="subtitle1" fontWeight="500">
						Ordenar por:
					</Typography>
				</Box>

				<FormControl size="small" sx={{ minWidth: 250 }}>
					<InputLabel>Campo</InputLabel>
					<Select value={currentSort.field} onChange={handleFieldChange} label="Campo">
						{sortOptions.map((option) => (
							<MenuItem key={option.field} value={option.field}>
								{option.label}
							</MenuItem>
						))}
					</Select>
				</FormControl>

				<FormControl size="small" sx={{ minWidth: 120 }}>
					<InputLabel>Orden</InputLabel>
					<Select value={currentSort.order} onChange={handleOrderChange} label="Orden">
						<MenuItem value="asc">Ascendente</MenuItem>
						<MenuItem value="desc">Descendente</MenuItem>
					</Select>
				</FormControl>

				<Typography variant="body2" color="text.secondary" sx={{ ml: 1 }}>
					{getCurrentFieldLabel()} ({currentSort.order === 'asc' ? 'A-Z' : 'Z-A'})
				</Typography>
			</Box>
		</Paper>
	);
};
